import { AppBar, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1200, 
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  position: 'fixed',
  width: '100%'
}));

export const StyledMenuButton = styled(IconButton)(({ theme }) => ({
  marginRight: 36,
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  flexGrow: 1,
}));

